<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLogger } from 'vue-logger-plugin'
import { BeeEntityWebAccountVerifyEmail } from '@/api/Business'
import { handleError } from '@/services/ErrorService'

const { t } = useI18n()
const logger = useLogger()
const isVerified = ref(false)

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search)
  const beeNumberToken = urlParams.get('beenumbertoken')

  try {
    if (!beeNumberToken) {
      throw new Error(t('errors.missingBeeNumberToken'))
    }

    await BeeEntityWebAccountVerifyEmail(beeNumberToken)
    isVerified.value = true
  } catch (error) {
    logger.error('AoeVerifyEmail error:', error)
    await handleError(error, t)
  }
})
</script>

<template>
  <div class="aoe-verify-email">
    <p v-if="isVerified">{{ t('messages.emailAddressVerified') }}</p>
  </div>
</template>

<style lang="scss">
.aoe-verify-email {
  padding: $card-padding;
}
</style>
